module.exports = __webpack_public_path__ + "img/smash2.ff28fd4f.png";